<div class="flex p-5 justify-between">
  <h1 class="text-2xl text-title" translate>eclass.aula.duplicar-aula</h1>
  <button type="button" app-icon-button dialogClose class="p-0!">
    <svg-icon class="h-8 w-8 select-none" src="assets/icons/icon-close-fine.svg"></svg-icon>
  </button>
</div>

<div app-modal-content class="h-auto p-0! flex flex-col items-center overflow-y-auto lg:max-h-[60rem] lg:w-[70rem]">
  <app-sidenav-daily class="w-11/12 h-full" [config]="data" (selected)="onTargets($event)"></app-sidenav-daily>
</div>

<div app-modal-footer class="w-full flex justify-end gap-2">
  <button
    app-outline-button
    class="h-fit w-48 border-theme-500 uppercase text-theme-500 hover:bg-theme-500 hover:text-theme-contrast"
    type="button"
    (click)="onClose()"
  >
    {{ 'geral.cancelar' | translate }}
  </button>
  <button
    app-icon-button
    type="button"
    [disabled]="(targets | isEmpty) || loading()"
    (click)="onSave()"
    class="w-48 gap-3 bg-theme-500 uppercase text-theme-contrast"
  >
    @if (loading()) {
      <app-skeleton basestyle="bg-theme-500" class="w-full h-full !h-5 !w-5"></app-skeleton>
    } @else {
      <svg-icon src="assets/icons/icon-duplicate-2.svg" class="flex h-5 w-5 text-white"></svg-icon>
    }
    {{ 'geral.duplicar' | translate }}
  </button>
</div>
